import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const PrintWavesGraphic = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 794 120",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 120),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: [/*#__PURE__*/jsx("path", {
      opacity: ".3",
      d: "M1069 40.08H-138.257V20.9C-47.32 26.473 57.41 4.32 109.892 4.97c47.837.603 70.176 14.118 201.797 14.118 131.622 0 153.218-3.25 228.318-16.209C578.416-3.762 657.416 25.87 696.8 20.528c31.861-4.32 81.927-20.482 110.583-13.84 100.179 23.268 204.817 4.458 260.267 11.75l1.35 21.643Z"
    }), /*#__PURE__*/jsx("path", {
      d: "M799.72 119.756H1069L1068.44 0c-31.16 52.62-189.348-3.901-269.928 12.075-80.58 15.977-119.128-9.567-176.161-3.483s-99.807 11.936-231.382 11.936S234.779 2.322 167.11 8.592C116.998 13.236 46.914 27.912-5.289 18.856-79.366 1.254-97.526 23.64-139 18.3l.697 101.968 134.733-.093 134.733-.093 668.557-.325Z"
    })]
  });
};

export { PrintWavesGraphic };
//# sourceMappingURL=waves.print.js.map
